import React from 'react';
import { Field } from 'redux-form';
import { isMobile } from 'react-device-detect';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {
  renderTextField,
  renderDateField,
  renderSelectField,
  CheckboxGroup,
  renderRadioGroup,
  renderHiddenField
} from './renders';
import moment from 'moment';

export const renderGenericTextField = (label, name) => {
  return (
    <Field 
      name={name} 
      component={renderTextField} 
      label={label} 
    />
  )
}

export const renderGenericHiddenField = (name, value) => {
  return (
    <Field
        name={name}
        component={renderHiddenField}
        type="hidden"
    />
  )
}

export const renderGenericCheckboxGroup = (data) => {
  const { 
    options, 
    name, 
    enableAnswer,
    enabledAnswerlabel,
    enabledAnswerAcceptedValues
  } = data;
  return (
    <Field 
      name={name}
      component={CheckboxGroup} 
      options={options || []}
      enableAnswer={enableAnswer}
      enabledAnswerlabel={enabledAnswerlabel}
      enabledAnswerAcceptedValues={enabledAnswerAcceptedValues}
    />
  )
}
export const renderEmailField = (label) => {

  return (
    <Field 
      name="email" 
      component={renderTextField} 
      label={label ? label : 'Dirección de correo electrónico'} 
      //validate={validators}
    />
  )
}

export const renderPasswordField = (label) => {
  return (
    <Field name="password" component={renderTextField} label={label ? label : 'Crea tu contraseña'} type="password" />
  )
}

export const renderLastNameField = (label) => {
  return (
    <Field name="last_name" component={renderTextField} label={label ? label : 'Primer apellido *'} />
  )
}

export const renderFirstNameField = (label) => {
  return (
    <Field name="first_name" component={renderTextField} label={label ? label : 'Nombre real * (Como aparece en el DNI)'} />
  )
}

export const renderSecondLastNameField = (label, name) => {
  return (
    <Field 
      name="second_last_name"
      component={renderTextField} 
      label={label ? label : 'Segundo apellido'} 
    />
  )
}

export const renderDateOfBirthField = (label, name, locale) => {
  let old = moment(new Date()).subtract(18, "years");
  return (
    <Field 
      name={name ? name : "birthday"} 
      component={renderDateField} 
      label={label ? label : 'Fecha de nacimiento *'} 
      //selected={this.state.birthday}
      //onChange={this.handleDateChange}
      locale={locale ? locale : 'es'}
      maxDate={old}
      initialDate={old}
    />
  )
}

export const renderCountriesField = (countries, label, name) => {
  return (
    <Field 
      name={name ? name : "country_of_birth"}
      component={renderSelectField} 
      data={countries}
      placeholder={label ? label : "País de nacimiento *"}
      native={isMobile}
    />
  )
}

export const renderRegionsField = (regions, label, name) => {
  return (
    <Field 
      name={name ? name : "region_of_birth" }
      component={renderSelectField} 
      data={regions}
      placeholder={label ? label : "Región de nacimiento"}
      native={isMobile}
      disabled={Object.keys(regions).length == 0}
    />
  )
}

export const renderCitiesField = (cities, label, name) => {
  return (
    <Field 
      name={name ? name : "city_of_birth"} 
      component={renderSelectField} 
      data={cities}
      placeholder={label ? label : "Ciudad de nacimiento"}
      native={isMobile}
      disabled={Object.keys(cities).length == 0}
    />
  )
}

export const renderNationalitiesField = (nationalities, label, name) => {
  return (
    <Field 
      name={name ? name : "nationality" }
      component={renderSelectField} 
      data={nationalities}
      placeholder={label ? label : "Nacionalidad *"}
      native={isMobile}
    />
  )
}

export const renderDniField = (label, name) => {
  return (
    <Field 
      name={name ? name : "dni"}
      component={renderTextField} 
      label={label ? label : 'DNI / NIE *'} 
    />
  )
}

export const renderAddressField = (label, name) => {
  return (
    <Field 
      name={name ? name : "address" }
      component={renderTextField} 
      label={label ? label : 'Dirección *'} 
    />
  )
}

export const renderCityField = (label, name) => {
  return (
    <Field 
      name={name ? name : "city" }
      component={renderTextField} 
      label={label ? label : 'Población *' }
    />
  )
}

export const renderPostalCodeField = (label, name) => {
  return (
    <Field 
      name={name ? name : "postal_code" }
      component={renderTextField} 
      label={label ? label : 'C.P.: *' }
      type="tel"
    />
  )
}

export const renderMobilePhoneField = (label, name) => {
  return (
    <Field 
      name={name ? name : "mobile_phone_number"} 
      component={renderTextField} 
      label={label ? label : 'Tel. móvil *' }
      type="tel"
    />
  )
}

export const renderAlternativePhoneNumberField = (label, name) => {
  return (
    <Field 
      name={name ? name : "alternative_phone_number" }
      component={renderTextField} 
      label={label ? label : '2º Tel. de contacto'} 
      type="tel"
    />
  )
}

export const renderTestTypeField = (preferred_test_types, label, name) => { 
  return (
    <Field 
      name={name ? name : "test_type"} 
      component={CheckboxGroup} 
      options={preferred_test_types}  
    />
  )
}

export const renderTestApplicationZone = (preferred_application_zones, label, name) => {
  return (
    <Field 
      name={name ? name : "test_application_zone"} 
      component={CheckboxGroup} 
      options={preferred_application_zones}  
    />
  )
}

export const renderContactMethodsField = (options, name) => {

  let defaultOptions = [
    {id: 1, value: 'Teléfono móvil (SMS)'},
    {id: 2, value: 'Correo electrónico'},
  ];

  return (
    <Field 
      name={name ? name : "contact_method" }
      component={CheckboxGroup} 
      options={options ? options : defaultOptions}  
    />
  )
}

export const renderContactTimeFiled = (options, name) => {
  let defaultOptions = [
    {id: 1,  value: 'Mañanas (9:00 a 11:30h)'},
    {id: 2,  value: 'Mañanas (11:30 a 13:30h)'},
    {id: 3,  value: 'Tardes (14:30 a 18:00h)'},
  ];

  return (
    <Field 
      name={name ? name : "contact_time" }
      component={CheckboxGroup} 
      options={options ? options : defaultOptions}  
    />
  )
}

export const renderGenderField = (label, name) => {
  return (
    <Field name={name ? name : "gender"} component={renderRadioGroup} style={{display: 'block'}}>
      <FormControlLabel control={<Radio />} value='1' label='Femenino' style={{width: '45%',float: 'left'}} />
      <FormControlLabel control={<Radio />} value='0' label='Masculino' style={{width: '45%',float: 'left'}} />
    </Field>
  )
}

export const renderHeightField = (label, name) => {
  return (
    <Field name={name ? name : "height"} component={renderTextField} label={label ? label : 'Altura (m)'} />
  )
}

export const renderWeightField = (label, name) => {
  return (
    <Field name={name ? name : "weight"} component={renderTextField} label={label ? label : 'Peso (kg)'} />
  )
}

export const renderOptionsField = (input) => {

  const { name, label, options, fullWidth, alignTop } = input;
console.log(input);
  return (
    <Field name={name} component={renderRadioGroup} style={{display: 'block'}}>
      {options && options.map((item) =>
        <FormControlLabel 
          key={item.id} 
          control={<Radio style={{paddingTop: alignTop ? 0 : 12}} />} 
          value={item.id.toString()} 
          label={item.value} 
          style={{
            width: fullWidth ? '100%' : (isMobile ? '45%' : '10%'),
            float: fullWidth ? 'inherit' : 'left',
            marginBottom: alignTop ? 15 : 'initial',
            marginRight: 30
          }}
        />
      )}
    </Field>
  )
}




// WEBPACK FOOTER //
// ./src/helpers/form/fields.js